import { Fragment, useEffect } from 'react';
import { Route } from 'react-router-dom';
import EnterPhone from '../Entrance/EnterPhone';
import Enterverfcode from '../Entrance/Enterverfcode';
import Personalinfo from '../Entrance/personalinfo';
import Shopinfo from '../Entrance/Shopinfo';
import Addshop from '../Entrance/Addshop';
import Confim from '../Entrance/Confirminfo';

const Entrnace = (props) => {
	return (
		<Fragment>
			<Route exact path="/entrance" component={EnterPhone} data={props} />
			<Route exact path="/entrance/step2" component={Enterverfcode} />
			<Route exact path="/entrance/step3" component={Personalinfo} />
			<Route exact path="/entrance/step4" component={Shopinfo} />
			<Route exact path="/entrance/step5" component={Addshop} />
			<Route exact path="/entrance/step6" component={Confim} />
		</Fragment>
	);
};

export default Entrnace;
